import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import { resetSession } from "../../../../redux/auth";
import { RootState } from "../../../../redux/rootReducers";
import {
  AddJobsTypePayload,
  JobDataType,
  JobErrorType,
  uniqueCheckJobType,
} from "../../../../commonTypes/jobsType";
import {
  addJobsTypeAction,
  checkUniqueJobTypeAction,
  resetError,
  resetMessage,
  resetStatusCode,
  resetSuccess,
  resetUniqiueCheckFetching,
  resetUniqueCheckMessage,
} from "../../../../redux/jobs";
import { connect } from "react-redux";
import "../../styles/jobs.scss";
import { PERIOD_OPTIONS } from "../../../../components/Jobs/JobsType/AddEditJobType/RecurringJobSetting";
import { Toaster } from "react-hot-toast";
import {
  CREATE_JOB_ON,
  JOB_TYPE_OPTIONS,
  REPEAT_JOB_OPTIONS,
} from "../../../../constant/jobs";
import AddEditJobCard from "../../../../components/Jobs/JobsType/AddEditJobType";
import useDebounce from "../../../../customHooks/useDebounce";

type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string;
  statusCode: number | null;
  history?: any;
  uniqueCheckMessage: string;
  uniqueCheckFetching: boolean;
  dispatchAddJobsType: (data: AddJobsTypePayload) => void;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchCheckUnqiueJobType: (data: uniqueCheckJobType) => void;
  dispatchResetUniqueMessage: () => void;
};

const AddJobType = ({
  token,
  success,
  fetching,
  error,
  statusCode,
  history,
  message,
  uniqueCheckFetching,
  uniqueCheckMessage,
  dispatchResetSession,
  dispatchResetMessage,
  dispatchAddJobsType,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetStatusCode,
  dispatchCheckUnqiueJobType,
  dispatchResetUniqueMessage,
}: AppProps) => {
  const [jobData, setJobData] = useState<JobDataType>({
    jobType: "",
    shortCode: "",
    jobFrequency: JOB_TYPE_OPTIONS[0].id,
    jobDescription: "",
    nextJob: "",
    repeat: REPEAT_JOB_OPTIONS[0],
    periodLength: PERIOD_OPTIONS[0],
    nextPeriodEnd: `${new Date().getDate().toString().padStart(2, "0")}-${(
      new Date().getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${new Date().getFullYear()}`,
    jobCreatedOn: CREATE_JOB_ON[1],
    targetStartDate: { value: "", label: "Select..." },
    WaitPostPeriodStartDate: { value: "", label: "Select..." },
    targetEndDate: { value: "", label: "Select..." },
    WaitPostPeriodEndDate: { value: "", label: "Select Period" },
    country: { value: "IN", label: "India" },
    setJobStatus: { value: "", label: "" },
    numberOfDaysToAddComment:""

  });

  const [jobsError, setJobsError] = useState<JobErrorType>({
    jobType: "",
    shortCode: "",
    jobDescription: "",
    nextPeriodEnd: "",
    targetStartDate: "",
    WaitPostPeriodStartDate: "",
    targetEndDate: "",
    WaitPostPeriodEndDate: "",
  });

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetMessage();
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetStatusCode();
    resetData();
  }, []);

  useEffect(() => {
    resetRecurring();
  }, [jobData?.jobFrequency]);

  useDebounce(
    () => {
      if (jobData?.jobType) {
        const finalData = {
          token,
          job_type: jobData?.jobType?.trim(),
          operation: "add",
        };
        dispatchCheckUnqiueJobType(finalData);
      }
    },
    500,
    [jobData?.jobType]
  );

  useEffect(() => {
    setJobData((prev: JobDataType) => ({
      ...prev,
      WaitPostPeriodStartDate: { value: "", label: "Select..." },
    }));
  }, [jobData?.jobCreatedOn]);
  const handleChange = (data: any, name: string) => {
    if (name === "jobType") {
      dispatchResetUniqueMessage();
    }

    switch (name) {
      case "jobType":
      case "shortCode":
      case "numberOfDaysToAddComment":
      case "jobDescription":
        setJobData((prev: JobDataType) => ({
          ...prev,
          [name]: data.target.value,
        }));
        setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }));
        break;
      case "periodEndRequired":
        setJobData((prev: JobDataType) => ({
          ...prev,
          [name]: data.target.checked,
        }));
        setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }));
        break;
      case "jobFrequency":
      case "nextPeriodEnd":
      case "nextJob":
        setJobData((prev: JobDataType) => ({ ...prev, [name]: data }));
        setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }));
        break;
      default:
        setJobData((prev: any) => ({ ...prev, [name]: { ...data } }));
        setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = () => {
    const {
      jobType,
      repeat,
      country,
      nextJob,
      jobCreatedOn,
      jobFrequency,
      periodLength,
      jobDescription,
      shortCode,
      nextPeriodEnd,
      targetStartDate,
      WaitPostPeriodStartDate,
      targetEndDate,
      setJobStatus,
      WaitPostPeriodEndDate,
      numberOfDaysToAddComment
    } = jobData;
    let finalData: any = {};
    if (
      !!jobType?.trim() &&
      !!shortCode?.trim() &&
      !!jobDescription?.trim() &&
      jobFrequency != "RecurringJob"
    ) {
      finalData = {
        job_type: jobType.trim(),
        short_code: shortCode.trim(),
        number_of_days_to_add_comment:numberOfDaysToAddComment == 0 ? null : numberOfDaysToAddComment,
        job_details: jobDescription.trim(),
        is_recurring: jobFrequency === "RecurringJob" ? true : false,
        recurring_job_settings: {
          repeat_period: "",
          repeat_period_length: "",
          next_period_end_date: "",
          create_job_period: "",
          next_job_start_date: "",
          target_start_date: {
            period_length: "",
            period: "",
          },
          target_end_date: {
            period_length: "",
            period: "",
          },
          country: country?.label,
          job_status: 1,
        },
      };
      dispatchAddJobsType({ data: finalData, token });
    } else if (
      !!jobType?.trim() &&
      !!shortCode?.trim() &&
      !!jobDescription?.trim() &&
      !!jobFrequency &&
      !!repeat?.value &&
      !!periodLength?.value &&
      !!nextPeriodEnd &&
      !!targetEndDate?.value &&
      !!WaitPostPeriodEndDate?.value
    ) {
      finalData = {
        job_type: jobType,
        short_code: shortCode,
        number_of_days_to_add_comment:numberOfDaysToAddComment == 0 ? null : numberOfDaysToAddComment,
        job_details: jobDescription,
        is_recurring: jobFrequency === "RecurringJob" ? true : false,
        recurring_job_settings: {
          repeat_period: repeat?.value,
          repeat_period_length: periodLength?.value,
          next_period_end_date: nextPeriodEnd,
          create_job_period: jobCreatedOn?.value,
          next_job_start_date: nextJob,
          target_start_date: {
            period_length: targetStartDate?.value,
            period: WaitPostPeriodStartDate?.value,
          },
          target_end_date: {
            period_length: targetEndDate?.value,
            period: WaitPostPeriodEndDate?.value,
          },
          country: country?.label,
          job_status: 1,
        },
      };
      dispatchAddJobsType({ data: finalData, token });
    } else {
      setJobsError((prev: any) => ({
        ...prev,
        ...(!jobType?.trim()
          ? { jobType: "Job Type Required" }
          : { jobType: "" }),
        ...(!shortCode?.trim()
          ? { shortCode: "Short Code Required" }
          : { shortCode: "" }),
        ...(!jobDescription?.trim()
          ? { jobDescription: "Job Description Required" }
          : { jobDescription: "" }),
        ...(!nextPeriodEnd && jobFrequency === "RecurringJob"
          ? {
              nextPeriodEnd: "Required",
            }
          : { nextPeriodEnd: "" }),
        ...(!targetEndDate?.value && jobFrequency === "RecurringJob"
          ? {
              targetEndDate: "Required",
            }
          : { targetEndDate: "" }),
        ...(!WaitPostPeriodEndDate?.value && jobFrequency === "RecurringJob"
          ? {
              WaitPostPeriodEndDate: "Required",
            }
          : { WaitPostPeriodEndDate: "" }),
      }));
    }
  };

  const resetData = () => {
    setJobsError({
      jobType: "",
      shortCode: "",
      jobDescription: "",
      nextPeriodEnd: "",
      targetStartDate: "",
      WaitPostPeriodStartDate: "",
      targetEndDate: "",
      WaitPostPeriodEndDate: "",
    });

    setJobData({
      jobType: "",
      shortCode: "",
      numberOfDaysToAddComment:"",
      jobFrequency: JOB_TYPE_OPTIONS[0].id,
      jobDescription: "",
      nextJob: "",
      repeat: REPEAT_JOB_OPTIONS[0],
      periodLength: PERIOD_OPTIONS[0],
      nextPeriodEnd: `${new Date().getDate().toString().padStart(2, "0")}-${(
        new Date().getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${new Date().getFullYear()}`,
      jobCreatedOn: CREATE_JOB_ON[1],
      targetStartDate: { value: "", label: "Select..." },
      WaitPostPeriodStartDate: { value: "", label: "Select..." },
      targetEndDate: { value: "", label: "Select..." },
      WaitPostPeriodEndDate: { value: "", label: "Select Period" },
      country: { value: "IN", label: "India" },
      setJobStatus: { value: "", label: "" },
    });
  };

  const resetRecurring = () => {
    setJobsError((prev: JobErrorType) => ({
      ...prev,
      nextPeriodEnd: "",
      targetStartDate: "",
      WaitPostPeriodStartDate: "",
      targetEndDate: "",
      WaitPostPeriodEndDate: "",
    }));

    setJobData((prev: JobDataType) => ({
      ...prev,
      repeat: REPEAT_JOB_OPTIONS[0],
      periodLength: PERIOD_OPTIONS[0],
      nextPeriodEnd: `${new Date().getDate().toString().padStart(2, "0")}-${(
        new Date().getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${new Date().getFullYear()}`,
      jobCreatedOn: CREATE_JOB_ON[1],
      targetStartDate: { value: "", label: "Select..." },
      WaitPostPeriodStartDate: { value: "", label: "Select..." },
      targetEndDate: { value: "", label: "Select..." },
      WaitPostPeriodEndDate: { value: "", label: "Select Period" },
    }));
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSuccess();
              dispatchResetError();
            }}
          />
        );
      }
    } else if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Job Type Added Successfully"
          buttonText="OK"
          onPress={() => {
            dispatchResetSuccess();
            history?.push({
              pathname: "/jobs/jobs-type",
            });
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader title="Create Job Type" />
      </div>

      <div className="col-md-12">
        <div className="jobs-card" style={{ padding: "15px 30px" }}>
          <div className="heading"> Create New Job Type</div>
          <div className="sub-heading">
            Add details below to create job type.
          </div>

          <AddEditJobCard
            jobData={jobData}
            handleChange={handleChange}
            jobsError={jobsError}
            handleSubmit={handleSubmit}
            history={history}
            fetching={fetching}
            uniqueCheckMessage={uniqueCheckMessage}
            uniqueCheckFetching={uniqueCheckFetching}
          />
        </div>
      </div>
      {handleErrorModal()}
      {fetching && <Loader />}
      <Toaster />
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.jobs.jobTypeFetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  message: state.jobs.message,
  isJobType: state.jobs.isJobType,
  uniqueCheckMessage: state.jobs.uniqueCheckMessage,
  uniqueCheckFetching: state.jobs.uniqueCheckFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchResetError: () => dispatch(resetError()),
  dispatchAddJobsType: (data: AddJobsTypePayload) =>
    dispatch(addJobsTypeAction(data)),
  dispatchCheckUnqiueJobType: (data: uniqueCheckJobType) =>
    dispatch(checkUniqueJobTypeAction(data)),
  dispatchResetUniqueMessage: () => dispatch(resetUniqueCheckMessage()),
  dispatchResetUniqueFetching: () => dispatch(resetUniqiueCheckFetching()),
});

export default connect(mapStateTopProps, mapDispatchToProps)(AddJobType);
